'use client'

export function DocsLink() {
  return (
    <div style={{ padding: '4px 16px 12px' }}>
      <a
        href="https://www.scdp-bistrita.ro/documentatie"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '8px 12px',
          borderRadius: '6px',
          fontSize: '13px',
          fontWeight: 500,
          color: 'var(--theme-text)',
          textDecoration: 'none',
          border: '1px solid var(--theme-border-color)',
          background: 'var(--theme-bg)',
          transition: 'background 0.15s',
        }}
        onMouseEnter={e => (e.currentTarget.style.background = 'var(--theme-elevation-100)')}
        onMouseLeave={e => (e.currentTarget.style.background = 'var(--theme-bg)')}
      >
        <span style={{ fontSize: '16px' }}>📖</span>
        Documentație utilizator
      </a>
    </div>
  )
}
